


































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import ProjectServer from '@/models/ProjectServer';
import Project from '../models/Project';
import { DelegateBuilder, IDelegate } from '@/models/DelegateBuilder';
import Mutations from '@/store/mutations'
import ChatRoot from '@/components/chat/ChatRoot.vue'
import { deserialize, deserializeDataIntoVuexStore } from '@/util/Serialization'
import SnapshotData from '../models/SnapshotData';
import { IsSchemaCompatible, SchemaVersion } from '@/util/embed_schema';

@Component(
{
	components: {
		ChatRoot,
	},
})
export default class EventListEditor extends Vue
{
	get defer_load()
	{
		return this.$route.params['encoded'].startsWith('framesrc') || this.$route.params.encoded.startsWith('snapshot_');
	}

	get deferred_data()
	{
		if (!this.defer_load) return {};
		console.log('parsing deferred data');
		return JSON.parse(atob(decodeURIComponent(this.$route.params['encoded'].slice('framesrc_'.length))));
	}

	// Computed
	get encoded()
	{
		if (this.defer_load)
		{
			//let hostname = decodeURIComponent(atob(this.$route.params['encoded'].slice('framesrc_'.length)));
			//console.log(hostname);
			return (window as any).embedData as string;
			/*
			if (window.parent && typeof((window.parent as any)[varName]) === 'string')
			{
				return ((window.parent as any)[varName] as string)
			}

			throw {
				error: "Failed to load embedded project data",
				detail:
				{
					error: window.parent ? 'Parent frame does not exist' : 'Could not load data from parent frame'
				}
			}*/
		}
		return this.$route.params['encoded'];
	}

	get deserialized()
	{
		console.log(`Reading encoded data of length ${this.encoded.length}`);
		return deserialize(this.encoded);
	}

	// Data
	openUpdateInterval = <any>null;
	invalid = false;
	error = ''
	errorTitle : string | null = null;
	loaded = false;
	
	// Methods
	projectLoaded() : Boolean
	{
		return this.connected && this.loaded;
	}

	connected() : Boolean
	{
		return true;
	}

	connecting() : Boolean
	{
		return false;
	}

	routeValid() : Boolean
	{
		let params = this.$route.params['encoded'];
		return params != undefined && params != null;
	}

	beforeRouteEnter(to : any, from : any, next : any)
	{
		console.log("Entering embedded project...")
		if (to.meta.isRoot)
		{
			//next('/app/e/timelines');
			//return;
		}
		next();
	}

	beforeRouteLeave(to : any, from : any, next : any)
	{
		console.log(`[LEAVE] from ${from.path} to ${to.path}`);
		if (to.path.toLowerCase().indexOf("/app/project") == -1)
		{
			ProjectServer.instance.disconnect();
			this.$store.commit(Mutations.resetProjectToDefault);
		}
		next();
	}

	_listener : any | null = null;

	async loadFromSnapshot()
	{
		let guid = this.$route.params.encoded.substring("snapshot_".length);
		try
		{
			let url = `sharedembed/${guid}`;
			if (this.$http.defaults.baseURL && this.$http.defaults.baseURL.startsWith('https://api.cliovis.com'))
			{
				url = 'https://cache.cliovis.com/' + url;
			}
			
			let resp = await this.$http.get<{status: string, embed: SnapshotData}>(url);
			if (!IsSchemaCompatible(resp.data.embed.schema_version))
			{
				this.errorTitle = "Incompatible Snapshot"
				this.error = `The provided snapshot was generated with an old or otherwise incompatible version of ClioVis.  Please use the correct snapshot URL to view the provided snapshot.  The snapshot had schema version ${resp.data.embed.schema_version}, this page has schema version ${SchemaVersion()}`
				this.invalid = true;
				return;
			}
			(window as any).embedData = resp.data.embed.data;
			
			// Make sure an instance exists
			ProjectServer.instance;

			console.log('Deserializing data into vuex store...')
			setTimeout(()=>{
				try
				{
					let deserialized = this.deserialized;
					console.log(deserialized);

					let tlid = -1;
					for(let k of deserialized.timelines)
					{
						tlid = k.id;
						break;
					}

					if (tlid == -1)
					{
						this.invalid = true;
						return;
					}

					let path = this.$route.path;
					if (!path.includes('/timeline/'))
					{
						if (!path.endsWith('/')) path = path + '/';
						path += 'timeline/' + tlid;
					}

					console.log(`NAVIGATING TO ${path}`);
					this.$router.push(path);

					deserializeDataIntoVuexStore(deserialized);
					console.log('Data was deserialized');
					console.log("Attempting to refresh navbar..");
					this.loaded = true;
					const wnd = window as any;
					if (wnd.forceRefreshNavbar)
					{
						this.$nextTick(()=>{
							wnd.forceRefreshNavbar();
						})
						console.log("Updated navbar");
					}
					else
					{
						console.log("Failed to update navbar");
					}
				}
				catch(ex)
				{
					if (ex.error)
					{
						this.invalid = true;
						this.error = ex.error + ` ${(ex.detail ? JSON.stringify(ex.detail) : 'No detail provided')}`;
					}
					else
					{
						throw ex;
					}
				}
			}, 16);
		}
		catch(err)
		{
			let resp = err.response;
			if (resp.status == 404)
			{
				this.errorTitle = "Snapshot not found"
				this.error = "Please provide a valid snapshot link"
				this.invalid = true;
			}
		}
	}

	mounted()
	{
		if (!this.routeValid())
		{
			this.invalid = true;
			return;
		}
		
		if (this.defer_load)
		{
			if (this.$route.params.encoded.startsWith('snapshot_'))
			{
				this.loadFromSnapshot();
				return;
			}

			console.log('using deferred data');
			window.parent.postMessage({call: this.deferred_data.message_name}, this.deferred_data.hostname);
			console.log('used deferred data');

			this._listener = (ev : MessageEvent)=>{
				var origin = ev.origin || (event as any).originalEvent.origin;
				if (typeof ev.data == 'object' && ev.data.call=='sendValue') {
					// Assign the embed data
					(window as any).embedData = ev.data.value;

					// Make sure an instance exists
					ProjectServer.instance;

					console.log('Deserializing data into vuex store...')
					setTimeout(()=>{
						try
						{
							deserializeDataIntoVuexStore(this.deserialized);
							console.log('Data was deserialized');
							console.log("Attempting to refresh navbar..");
							this.loaded = true;
							const wnd = window as any;
							if (wnd.forceRefreshNavbar)
							{
								this.$nextTick(()=>{
									wnd.forceRefreshNavbar();
								})
								console.log("Updated navbar");
							}
							else
							{
								console.log("Failed to update navbar");
							}
						}
						catch(ex)
						{
							if (ex.error)
							{
								this.invalid = true;
								this.error = ex.error + ` ${(ex.detail ? JSON.stringify(ex.detail) : 'No detail provided')}`;
							}
							else
							{
								throw ex;
							}
						}
					}, 16);
				}
			}

			window.addEventListener('message', this._listener)
			return;
		}
		
		try
		{
			deserializeDataIntoVuexStore(this.deserialized);
			console.log('Data was deserialized');
			this.loaded = true;
		}
		catch(ex)
		{
			if (ex.error)
			{
				this.invalid = true;
				this.error = ex.error + ` ${(ex.detail ? JSON.stringify(ex.detail) : 'No detail provided')}`;
			}
			else
			{
				throw ex;
			}
		}
	}

	beforeDestroy()
	{
	}
}
